import type PaymentMethods from '~/types/PaymentMethods';

import { ActionKeys } from '~/actions/constants';
import { type ActionTypes } from '~/actions/index';

export type BillingState = {
  paymentMethods: PaymentMethods;
  showCreditCardModal: boolean;
};

export const paymentMethodsInitialState: PaymentMethods = {
  achAccountNumberLast4: '',
  achAuthorized: false,
  billingFrequency: 0,
  blockedBilling: false,
  paymentCurrency: '',
  paymentThreshold: 0,
  paymentType: '',
  stripeAchSet: false,
  stripeAuthorized: false,
  stripeCcBrand: '',
  stripeCcExpMonth: 0,
  stripeCcExpYear: 0,
  stripeCcLast4: 0,
  stripeCreditCardSet: false,
  stripePublishableKey: '',
  stripeToken: '',
};

export const initialState: BillingState = {
  paymentMethods: paymentMethodsInitialState,
  showCreditCardModal: false,
};

const reducer = (state: BillingState = initialState, action: ActionTypes) => {
  switch (action.type) {
    case ActionKeys.BILLING_OPEN_CREDIT_CARD_MODAL:
      return {
        ...state,
        showCreditCardModal: true,
      };
    case ActionKeys.BILLING_CLOSE_CREDIT_CARD_MODAL:
      return {
        ...state,
        showCreditCardModal: false,
      };
    default:
      return state;
  }
};

export default reducer;
